// Pure maths behind the collapsed sticky header, split out from the hook so the
// thresholds can be exercised without a scrolling document.

// Height of the docked bar (incl. its bottom hairline) — kept in sync with
// `.league-detail__sticky-inner` in the CSS. Used to inset the intersection root so a row hidden
// *behind* the bar counts as offscreen, not visible.
export const STICKY_BAR_HEIGHT = 53
// Hysteresis band (~24px) around the hero rank block's bottom edge so a scroll settling on the
// boundary can't flip the collapse state back and forth. Collapse once the edge passes above the
// viewport top (bottom < 0); only expand again once it comes back down past +24px.
const COLLAPSE_AT = 0
const EXPAND_AT = 24

/** Next collapse state from the hero rank block's viewport-relative bottom edge. */
export function nextCollapsedState(
  wasCollapsed: boolean,
  heroBottom: number
): boolean {
  return wasCollapsed ? heroBottom < EXPAND_AT : heroBottom < COLLAPSE_AT
}

/**
 * Document scroll offset that centres the user's row in the viewport (not pinned to an edge).
 * Clamped at the top of the document so a row near the top doesn't ask for a negative scroll.
 */
export function centredScrollTop(
  row: { top: number; height: number },
  scrollY: number,
  viewportHeight: number
): number {
  const target = scrollY + row.top - (viewportHeight - row.height) / 2
  return Math.max(0, target)
}
